<template>
  <div>
    <nav-title :color="true" :title="'Parenting Solutions'" />
    <data-description>
      <div class="d-flex align-items-center justify-content-center">
        <span class="mr-2">{{ description }}</span>
        <question-popup
          :title="quickTipsPopups.problem.title"
          :description="quickTipsPopups.problem.information"
          popover-key="quick-tips"
          class="text-main2"
        />
      </div>
    </data-description>
    <b-link class="text-right d-block py-2 px-4 bg-light small" to="/help-saved-solving">
      <i class="material-icons align-middle">
        emoji_objects
      </i>
      <p class="m-0 d-inline align-middle">
        Saved Problem Solving
      </p>
    </b-link>
    <section class="container pb-4">
      <b-form-group class="mx-auto my-3">
        <b-form-radio-group
          v-model="problem"
          name="butons1"
          class="customCheck1"
          button-variant="light"
          :options="getProblemList"
          stacked
          buttons
        >
        </b-form-radio-group>
      </b-form-group>
      <div class="d-flex mb-3 flex-column flex-sm-row">
        <b-button
          :disabled="problem.length == 0"
          variant="info"
          @click="sendDataTips"
          class="text-capitalize w-100 mr-3 rounded-pill mb-3 mb-sm-0"
        >
          Quick Tips
        </b-button>
        <b-button
          :disabled="problem.length == 0"
          variant="warning"
          @click="sendDataSolving"
          class="text-capitalize w-100"
        >
          Problem Solving
        </b-button>
      </div>
    </section>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import store from '@/store';
import dataDescription from '@/components/general/dataDescription.vue';
import navTitle from '@/components/general/navTitle.vue';
import QuestionPopup from '@/components/general/QuestionPopup.vue';

export default {
  name: 'HelpMain',
  components: {
    navTitle,
    dataDescription,
    QuestionPopup,
  },
  methods: {
    sendDataSolving() {
      let Mid = this.problem;
      this.$router.push({
        path: `/help-select-cause/${Mid}`,
      });
    },
    sendDataTips() {
      let Mid = this.problem;
      this.$router.push({
        path: `/help-quick-tips/${Mid}`,
      });
    },
  },
  computed: {
    ...mapGetters('help', ['getProblemList', 'quickTipsPopups']),
  },
  beforeRouteEnter(to, from, next) {
    Promise.all(
      [store.dispatch('help/FetchProblems')],
      store.dispatch('help/fetchPopupsToTips'),
    ).then(() => {
      next();
    });
  },
  data() {
    return {
      description:
        'Not sure where to start? Select a topic and tap Quick Tips or Problem Solving for suggestions',
      problem: [],
    };
  },
  async mounted() {
    try {
      console.log('data');
    } catch (error) {
      console.error('[Error | UI] It is not possible to obtain information from popups.');
    }
  },
};
</script>
<style lang="scss" scope>
.btn-group,
.btn-group-vertical {
  display: block;
}

.customCheck1 {
  width: 100%;
}

.customCheck1 label {
  background-color: #ffffff;
  border-color: transparent !important;
  color: var(--color-upp) !important;
  text-align: left;
  font-size: 1em;
  border-radius: 5px !important;
  padding: 10px 10px 10px 15px;
  -webkit-box-shadow: 2px 2px 5px 0px rgba(240, 240, 240, 1);
  -moz-box-shadow: 2px 2px 5px 0px rgba(240, 240, 240, 1);
  box-shadow: 2px 2px 5px 0px rgba(240, 240, 240, 1);
}

.btn-group-toggle > .btn,
.btn-group-toggle > .btn-group > .btn {
  margin-bottom: 8px !important;
}

.customCheck1 .btn-light:not(:disabled):not(.disabled):active,
.customCheck1 .btn-light:not(:disabled):not(.disabled).active,
.customCheck1 .show > .btn-light.dropdown-toggle {
  background-color: var(--color-upp) !important;
  color: #ffffff !important;
  padding: 10px 10px 10px 30px;
}
.customCheck1 .btn-light:not(:disabled):not(.disabled):active::after,
.customCheck1 .btn-light:not(:disabled):not(.disabled).active::after,
.customCheck1 .show > .btn-light.dropdown-toggle::after {
  content: '✓';
  position: absolute;
  left: 10px;
  top: 10px;
}
.customCheck1 .btn:focus,
.btn.focus {
  box-shadow: none !important;
}
</style>
